module.exports = __webpack_public_path__ + "img/camera.01d8182c.svg";